import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cardDetail: [],
    reservationActivityLogsList: [],
    activityBookingId: 0,
    openGenerateFolioDialog: false,
};
const reservationViewSlice = createSlice({
  name: "reservationView",
  initialState: initialState,
  reducers: {
    cardDetailSuccess: (state, action) => {
      state.cardDetail = action.payload;
    },
    cardDetailFailed: (state, action) => {
      state.cardDetail = [];
    },
    reservationActivityLogsListSuccess: (state, action) => {
      state.reservationActivityLogsList = action.payload;
    },
    activityBookingIdSuccess: (state, action) => {
      state.activityBookingId = action.payload;
    },
    genrateFolioDialogSuccess: (state, action) => {
      state.openGenerateFolioDialog = true;
    },
    genrateFolioDialogFailed: (state, action) => {
      state.openGenerateFolioDialog = false;
    },
  },
});

export const {
  cardDetailSuccess,
  cardDetailFailed,
  reservationActivityLogsListSuccess,
  activityBookingIdSuccess,
  genrateFolioDialogSuccess,
  genrateFolioDialogFailed
} = reservationViewSlice.actions;

export default reservationViewSlice.reducer;
